<div class="chartWrapper">
  <div class="chartAreaWrapper" [ngStyle]="{'width': barChartWidth}">
      <canvas id="barChart" width="700" ></canvas>
  </div>
    <canvas id="chartAxis" width="0"></canvas>
</div>